<template>
  <div class="me-4">
    <button type="button" class="btn btn-light btn-sm" @click="open" title="Consultar créditos e consumo de IA">
      IA · {{ money(wallet ? wallet.disponivel : initialBalance) }}
    </button>
    <div v-if="visible" class="ia-wallet-backdrop" @click.self="visible = false" @keydown.esc="visible = false">
      <section class="ia-wallet card p-5" role="dialog" aria-modal="true" aria-labelledby="ia-wallet-title" tabindex="-1" ref="dialog">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h2 id="ia-wallet-title" class="fs-3">Créditos de IA</h2>
          <button type="button" class="btn btn-light btn-sm" @click="visible = false" aria-label="Fechar">Fechar</button>
        </div>
        <p v-if="error" role="alert">{{ error }}</p>
        <p v-if="loading" role="status">Consultando créditos…</p>
        <template v-if="wallet">
          <p>Disponível: <strong>{{ money(wallet.disponivel) }}</strong> · Em processamento: {{ money(wallet.reservado) }}</p>
          <p v-if="!wallet.cobranca_ativa" class="alert alert-info">Uso gratuito até 31/10/2026. A cobrança começa em 01/11/2026, no horário de Brasília, sem desconto retroativo.</p>
          <p>1 crédito equivale a R$ 1,00. Para adquirir créditos, entre em contato com o suporte comercial. O desconto depende do consumo de cada recurso.</p>
          <div class="table-responsive">
            <table class="table">
              <caption>Histórico de créditos e consumo de IA</caption>
              <thead><tr><th>Data</th><th>Movimento</th><th>Créditos</th><th>Saldo</th></tr></thead>
              <tbody><tr v-for="row in entries" :key="row.ID"><td>{{ date(row.CRIADO_EM) }}</td><td>{{ label(row.TIPO) }}</td><td>{{ money(row.VALOR) }}</td><td>{{ money(row.SALDO_APOS) }}</td></tr></tbody>
            </table>
            <p v-if="!entries.length">Nenhum movimento registrado.</p>
          </div>
          <button v-if="more" type="button" class="btn btn-light" :disabled="loading" @click="refresh(true)">Carregar anteriores</button>
        </template>
        <button type="button" class="btn btn-primary mt-3" :disabled="loading" @click="refresh(false)">Atualizar</button>
      </section>
    </div>
  </div>
</template>
<script>
import ApiService from '@/core/services/api.service';
export default {
  name: 'IaCredits',
  props: { initialBalance: { type: [Number, String], default: 0 } },
  data: () => ({ visible: false, loading: false, wallet: null, entries: [], more: false, error: '' }),
  mounted() { this.refresh(false); },
  methods: {
    money(value) { return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 8 }); },
    date(value) { return new Date(value.replace(' ', 'T') + 'Z').toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }); },
    label(type) { return { ABERTURA: 'Saldo inicial', RECARGA: 'Aquisição de créditos', SETTLED: 'Consumo de IA', CANCELLED: 'Reserva liberada', GRATUITO: 'Uso gratuito' }[type] || type; },
    async open() { this.visible = true; await this.$nextTick(); this.$refs.dialog?.focus(); this.refresh(false); },
    async refresh(append) {
      if(this.loading) return;
      this.loading = true; this.error = '';
      try {
        ApiService.setHeader();
        const before = append && this.entries.length ? this.entries[this.entries.length - 1].ID : 0;
        const { data } = await ApiService.get('creditosEnvios/access/obterCreditosIA', '?antes=' + encodeURIComponent(before));
        if(!data?.RESULTADO || !data.CARTEIRA || !Array.isArray(data.EXTRATO)) throw new Error();
        this.wallet = data.CARTEIRA;
        this.entries = append ? [...this.entries, ...data.EXTRATO] : data.EXTRATO;
        this.more = data.EXTRATO.length === 100;
      } catch { this.error = 'Não foi possível consultar os créditos de IA. Tente atualizar.'; }
      finally { this.loading = false; }
    }
  }
};
</script>
<style scoped>
.ia-wallet-backdrop { position: fixed; inset: 0; background: #0008; z-index: 1100; display: flex; justify-content: center; align-items: center; padding: 20px; }
.ia-wallet { width: min(780px, 100%); max-height: 90vh; overflow: auto; }
</style>
